import { Checkbox, HStack, Text } from '@chakra-ui/react';
import { SelectOption } from '@pelicargo/types';
import { ChakraStylesConfig } from 'chakra-react-select';
import { MultiValueProps, OptionProps } from 'react-select';

import { SimpleReactSelect } from './SimpleReactSelect';

const networksSelectStyles: ChakraStylesConfig = {
  multiValue: (provided) => ({
    ...provided,
    bg: 'transparent',
    background: 'transparent',
    border: 'none',
    borderWidth: 0,
    boxShadow: 'none',
    m: 0,
    p: 0,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    bg: 'transparent',
    background: 'transparent',
    p: 0,
    whiteSpace: 'normal',
  }),
  menuList: (provided) => ({
    ...provided,
    width: '100%',
    minW: '280px',
  }),
};

const NetworksOption = (props: OptionProps<SelectOption, true>) => {
  const { isSelected, isFocused, label, innerRef, innerProps } = props;

  return (
    <HStack
      ref={innerRef}
      {...innerProps}
      spacing="3"
      px="3"
      py="2"
      cursor="pointer"
      bg={isFocused ? 'gray.50' : 'transparent'}
      _hover={{ bg: 'bg.default' }}
      pointerEvents="auto"
    >
      <Checkbox isChecked={isSelected} colorScheme="primary" size="md" tabIndex={-1} pointerEvents="none" />
      <Text as="span">{label}</Text>
    </HStack>
  );
};

// Render all selections once as "A, B, C" — no chip / remove buttons.
const NetworksMultiValue = (props: MultiValueProps<SelectOption, true>) => {
  const { index, getValue } = props;
  if (index > 0) return null;

  const labels = getValue()
    .map((option) => option.label)
    .join(', ');

  return (
    <Text as="span" fontSize="md" px="2" py="1" noOfLines={2}>
      {labels}
    </Text>
  );
};

const networksSelectComponents = {
  Option: NetworksOption,
  MultiValue: NetworksMultiValue,
  MultiValueRemove: () => null,
};

type Props = {
  name: string;
  options: SelectOption[];
  label?: string;
  placeholder?: string;
  variant?: string;
};

export const NetworksSelect = ({
  name,
  options,
  label = 'Network(s)',
  placeholder = 'Select network(s)',
  variant = 'outline',
}: Props) => {
  return (
    <SimpleReactSelect
      name={name}
      label={label}
      placeholder={placeholder}
      variant={variant}
      isMulti
      options={options}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      blurInputOnSelect={false}
      tagVariant="unstyled"
      chakraStyles={networksSelectStyles}
      components={networksSelectComponents}
    />
  );
};
